/* Custom Back-in-Stock — posts to Klaviyo client API.
   - Back-in-stock subscription: always (records variant + timestamp in Klaviyo).
   - Newsletter subscription: only if the opt-in is checked AND a List ID is set.
   Language + config come from data-attributes on [data-og-bis-modal]:
     data-bis-key (public Site ID), data-bis-list (List ID), data-bis-lang (locale).
   The body text is personalised on open with the selected size. */
(function () {
  'use strict';
  var REVISION = '2026-04-15';
  var BIS_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var SUB_URL = 'https://a.klaviyo.com/client/subscriptions/';

  function isUk(modal) {
    var l = (modal && modal.getAttribute('data-bis-lang')) || document.documentElement.lang || '';
    return l.toLowerCase().indexOf('uk') === 0;
  }
  function msg(modal, kind) {
    var uk = isUk(modal);
    var M = {
      email:   uk ? 'Введіть коректний email.'                     : 'Please enter a valid email address.',
      terms:   uk ? 'Підтвердіть згоду з умовами, щоб продовжити.' : 'Please accept the terms to continue.',
      variant: uk ? 'Оберіть розмір.'                               : 'Please select a size first.',
      fail:    uk ? 'Не вдалося підписатись. Спробуйте ще раз.'     : 'Could not subscribe. Please try again.'
    };
    return M[kind] || '';
  }
  function bodyText(size, uk) {
    if (size) {
      return uk
        ? ('Коли розмір «' + size + '» знову зʼявиться в наявності, ми повідомимо вас на email. Залиште свою адресу нижче.')
        : ('When size ' + size + ' is available we’ll notify you via email. Please submit your email address below.');
    }
    return uk
      ? 'Ми повідомимо вас на email, щойно товар знову зʼявиться в наявності. Залиште свою адресу нижче.'
      : 'We’ll notify you via email when this item is back in stock. Please submit your email address below.';
  }
  function validEmail(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s); }

  function rootOf(modal) { return modal.closest('[data-og-pdp]'); }
  function variantOf(modal) {
    var root = rootOf(modal);
    var input = root && root.querySelector('[data-og-variant-id]');
    return (input && input.value) || '';
  }
  function sizeOf(modal) {
    var root = rootOf(modal);
    if (!root) return '';
    // The size picker renders selectable buttons with aria-checked; the chosen
    // (sold-out) one is what the shopper is subscribing to. Colour uses swatches,
    // so .og-pdp__size is size-specific. Falls back to no size → generic copy.
    var el = root.querySelector('.og-pdp__size[aria-checked="true"]');
    if (!el) return '';
    return (el.getAttribute('data-og-value') || el.textContent || '').trim();
  }

  function showView(modal, name) {
    var els = modal.querySelectorAll('[data-og-bis-view]');
    for (var i = 0; i < els.length; i++) {
      els[i].hidden = els[i].getAttribute('data-og-bis-view') !== name;
    }
  }
  function showError(modal, text) {
    var el = modal.querySelector('[data-og-bis-error]');
    if (el) { el.textContent = text; el.hidden = false; }
  }
  function clearError(modal) {
    var el = modal.querySelector('[data-og-bis-error]');
    if (el) { el.textContent = ''; el.hidden = true; }
  }

  function openModal(modal) {
    clearError(modal);
    var form = modal.querySelector('[data-og-bis-form]');
    if (form) form.reset();
    showView(modal, 'form');
    var textEl = modal.querySelector('[data-og-bis-text]');
    if (textEl) textEl.textContent = bodyText(sizeOf(modal), isUk(modal));
    modal.setAttribute('data-open', '');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var email = modal.querySelector('[data-og-bis-email]');
    if (email) setTimeout(function () { email.focus(); }, 60);
  }
  function closeModal(modal) {
    modal.removeAttribute('data-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function postBIS(key, email, variantId) {
    return fetch(BIS_URL + '?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    });
  }
  function postNewsletter(key, listId, email) {
    return fetch(SUB_URL + '?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    });
  }

  /* ── Open / close (delegated) ── */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-og-bis-open]');
    if (opener) {
      e.preventDefault();
      var root = opener.closest('[data-og-pdp]') || document;
      var modal = root.querySelector('[data-og-bis-modal]') || document.querySelector('[data-og-bis-modal]');
      if (modal) openModal(modal);
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-og-bis-close]');
    if (closer) {
      var m = closer.closest('[data-og-bis-modal]');
      if (m) closeModal(m);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var open = document.querySelector('[data-og-bis-modal][data-open]');
    if (open) closeModal(open);
  });

  /* ── Submit ── */
  function wire(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var modal = form.closest('[data-og-bis-modal]');
      if (!modal) return;
      var key = modal.getAttribute('data-bis-key');
      var listId = modal.getAttribute('data-bis-list');
      var variantId = variantOf(modal);
      var emailEl = form.querySelector('[data-og-bis-email]');
      var termsEl = form.querySelector('[data-og-bis-terms]');
      var newsEl = form.querySelector('[data-og-bis-news]');
      var btn = form.querySelector('[data-og-bis-submit]');
      var email = (emailEl && emailEl.value || '').trim();

      clearError(modal);
      if (!validEmail(email)) { showError(modal, msg(modal, 'email')); return; }
      if (termsEl && !termsEl.checked) { showError(modal, msg(modal, 'terms')); return; }
      if (!variantId) { showError(modal, msg(modal, 'variant')); return; }

      if (btn) { btn.disabled = true; btn.setAttribute('data-loading', ''); }

      postBIS(key, email, variantId)
        .then(function (res) {
          if (!res || res.status < 200 || res.status >= 300) {
            throw new Error('bis HTTP ' + (res && res.status));
          }
          if (newsEl && newsEl.checked && listId) {
            return postNewsletter(key, listId, email).catch(function () { /* non-fatal */ });
          }
        })
        .then(function () {
          showView(modal, 'done');
          // Для аналітики — лише справжня підписка (Klaviyo відповів 2xx), з розміром (17D-215).
          try {
            window.dispatchEvent(new CustomEvent('og:bis:subscribed', { detail: { variantId: variantId, size: sizeOf(modal) } }));
          } catch (e) {}
        })
        .catch(function (err) {
          showError(modal, msg(modal, 'fail'));
          if (window.console) console.warn('[og-bis]', err);
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('data-loading'); }
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-og-bis-form]');
    for (var i = 0; i < forms.length; i++) wire(forms[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
